import { Add } from 'iconsax-react';
import { isEmpty } from 'rambda';
import { useTranslation } from 'react-i18next';
import useAdjustLayout from '@/hooks/use-adjust-layout';
import useSearchHistoryStore from '@/stores/search-history';
import cn from '@/utils/merge-class-names';

interface Props {
  onSearch: (search: string) => void;
  className?: string;
}

export default function SearchHistory({ onSearch, className }: Props) {
  const { t } = useTranslation();
  const { searchHistory, clearAllSearchHistory, removeSearchHistory } = useSearchHistoryStore();

  useAdjustLayout({ inputTargetSelector: 'input#search', layoutTargetSelector: '#scrollable' });

  return (
    <div className={cn('flex flex-col items-stretch mx-5 flex-1 justify-start bg-neutral-0', className)}>
      <div className='flex justify-between mt-2 mb-3'>
        <span className='font-bold'>{t('search.recent-search')}</span>

        {!isEmpty(searchHistory) && (
          <button
            type='button'
            className='btn btn-ghost btn-xs text-body2 text-secondary'
            onClick={() => clearAllSearchHistory()}>
            {t('search.delete-all')}
          </button>
        )}
      </div>

      <ul
        className='flex-1 overflow-y-auto overflow-x-hidden flex flex-col items-stretch'
        id='scrollable'>
        {searchHistory.map((history, index) => (
          <li
            key={`${index}-${history}`}
            className='flex items-center justify-between min-h-10'>
            <button
              type='button'
              className='flex-1 py-3 text-start break-all text-ellipsis overflow-hidden'
              onClick={() => onSearch(history)}>
              {history}
            </button>
            <button
              type='button'
              className='btn btn-ghost pe-0 btn-sm'
              onClick={() => removeSearchHistory(history)}>
              <Add
                size={20}
                className='rotate-45 text-secondary'
              />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
